import { useQuery } from '@tanstack/react-query'

import { getContentfulSettings } from '@/app/actions/getContentfulSettings'
import { Button } from '@/components/primitives/Button/Button'
import { DrawerClose } from '@/components/primitives/Drawer/Drawer'
import { Loader } from '@/components/primitives/Loader/Loader'

const defaultMessage = {
  title: 'Your submission has been received.',
  description: 'Thank you for your enquiry. A Supagas Representative will come back to you as soon as possible. ',
}

export function SuccessMessage({ type = 'page' }: { type?: 'page' | 'drawer' }) {
  const { data: settings, isLoading } = useQuery({
    queryKey: ['settings'],
    queryFn: () => getContentfulSettings(),
  })
  const formSubmissionMessage = settings?.fields?.formSubmissionMessage?.fields ?? defaultMessage

  return !isLoading ? (
    <div className="flex flex-col items-start justify-start gap-5">
      <div className="flex flex-col items-start justify-start gap-[3px]">
        <div className="text-base font-semibold text-neutral-900">{formSubmissionMessage?.title}</div>
        <div className="text-base text-neutral-700">{formSubmissionMessage?.description}</div>
      </div>
      {type === 'drawer' && (
        <DrawerClose>
          <Button variant="solid" className="w-full">
            Close
          </Button>
        </DrawerClose>
      )}
    </div>
  ) : (
    <div className="flex w-full items-center justify-center py-10">
      <Loader type="default" />
    </div>
  )
}
